import { render } from "./ReceiversAutocompleteSuggestion.vue?vue&type=template&id=2b9a93dd"
import script from "./ReceiversAutocompleteSuggestion.vue?vue&type=script&lang=js"
export * from "./ReceiversAutocompleteSuggestion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__